import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/equipment_productions',
  component: Management,
  redirect: '/equipment_productions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/equipment_productions/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEquipmentProductions
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/equipment_productions/ListTable'),
          meta: {
            auth: Auth.listEquipmentProductions,
            tabName: 'all'
          }
        },
        {
          path: 'activated',
          component: () => import('@/views/equipment_productions/ListTable'),
          meta: {
            auth: Auth.listEquipmentProductions,
            tabName: 'activated'
          }
        },
        {
          path: 'deactivated',
          component: () => import('@/views/equipment_productions/ListTable'),
          meta: {
            auth: Auth.listEquipmentProductions,
            tabName: 'deactivated'
          }
        },
        {
          path: 'dispatched',
          component: () => import('@/views/equipment_productions/ListTable'),
          meta: {
            auth: Auth.listEquipmentProductions,
            tabName: 'dispatched'
          }
        },
        {
          path: 'undispatched',
          component: () => import('@/views/equipment_productions/ListTable'),
          meta: {
            auth: Auth.listEquipmentProductions,
            tabName: 'undispatched'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/equipment_productions/New'),
      meta: {
        auth: Auth.createEquipmentProduction
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/equipment_productions/Edit'),
      meta: {
        auth: Auth.updateEquipmentProduction
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/equipment_productions/DetailLayout'),
      meta: {
        auth: Auth.showEquipmentProduction
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/equipment_productions/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEquipmentProduction
          }
        }
      ]
    }
  ]
}
